import useApproveOrRejectReturn from "@babackapp/private-api-client/client/use-approve-or-reject-return";
import { useUpdateReturnRequestInCache } from "@babackapp/private-api-client/client/use-invalidate-return-request";
import useTranslation from "@babackapp/translations/use-translation";
import { CheckCircle2Icon } from "lucide-react";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { useViewerHasAtLeastCustomerSupportRights } from "@/lib/rights/use-viewer-has-right";
import { useCurrentReturnRequest } from "@/pages/(app)/returns/utils/current-return-request-context";

export function useAuthorizeAction() {
	const { data: shop } = useCurrentShopSuspense();
	const returnRequest = useCurrentReturnRequest();
	const t = useTranslation();
	const hasCustomerRight = useViewerHasAtLeastCustomerSupportRights();
	const approvedAlready = returnRequest.status.approved.done;
	const isCancelled = returnRequest.status.cancelled.done;
	const updateReturnInReturnRequestInfiniteCache =
		useUpdateReturnRequestInCache();
	const { mutate, isPending } = useApproveOrRejectReturn({
		onSuccess(returnRequest) {
			updateReturnInReturnRequestInfiniteCache({ returnRequest });
		},
	});

	return {
		label: t("returnDetail.acceptedRequest"),
		enabled: hasCustomerRight && !approvedAlready && !isCancelled,
		icon: <CheckCircle2Icon className="h-5 w-5 text-green-400" />,
		loading: isPending,
		onClick: () => {
			mutate({
				shopId: shop.id,
				returnRequestId: returnRequest.id,
				status: "ok",
			});
		},
	};
}
